function parallaxAnimation() {
  const containers = gsap.utils.toArray(".parallax-effect");
  if (containers) {
    containers.forEach((section) => {
      gsap.to(section, {
        scrollTrigger: {
          trigger: section,
          start: "top top",
          pin: true,
          pinSpacing: false,
          scrub: 0.5,
        },
      });
    });
  }
}

export default parallaxAnimation;
